import type { CSSProperties } from '@linaria/core';
import { cx } from '@linaria/core';
import { useCallback, useEffect, useRef } from 'react';
import { avatarUrl } from '../../../mfcLogic/avatarPreviewUrl';
import { getExploreScrollPosition, setExploreScrollPosition } from '../../../state/state.grid';
import { isTouchDevice } from '../../../utilities/browser';
import Placeholder from './Displays/Placeholder';
import "./UserRow.linaria.module.css!=!./UserRow?./UserRow.linaria.module.css?css=H4sIAAAAAAAAA22RzXKDIBRG932L7urCTLT5MfZhGBTUG65gABXD9N07aSLVpDsO9/DBfGyobYkwpDm7PWZeDVxXqMZ8AAMF8ndoO6Utlfbr+21zc0+GJNaNMKBnYDqkU14hd/MYt6QQ9HDgawrBsctNqRXiazIiScr9rjqNT+g7yhjIOtZQNzYfqP6I49VeFDIEaZOjc8c1hQTk1XPAbSuc5ylJmNhfgPqGL267Q9CGiehrb3XqR2C2eUi/62hZlMoQpksoCiSC5HGBqhRBOxOLgm/Rl702SuedAmm5nudFQYB1Vb1bk7+VHptGgxT5dpapW8qB7nKt1finYkZ2fQGFnLtZ1xIt3nf8pGw8z+9jvKI9hl8rM3IqUz65NflKSRsbuPJHbuDo9ed5Srr+elDi39JX/g+1waNisAIAAA=="
const rowContainerStyles = "atm_ks_hjx5l8 atm_9s_1txwivl";
const rowContainerTouchStyles = "atm_l0_bka66e atm_9s_1txwivl";
const rowStyles = "atm_ll_1c54f9w atm_lk_m17xx7 atm_e2_1dk5qia atm_vy_rzutr2 atm_9s_1o8liyq atm_9j_tlke0l atm_bb_idpfg4 atm_ax_idpfg4";
const stylesRoot = "atm_l8_4ubibn";
// placeholder cells are not rooms: no pointer affordance
const stylesPlaceholderCell = "atm_9j_73adwj";
const stylesSeeAllClass = "atm_c8_9c2eyx atm_e2_puz6ok";
const UserRow = props => {
  const {
    displayComponentProps,
    saveScrollPosition,
    DisplayComponent,
    SeeAllComponent,
    seeAllOnClick,
    displayHeight,
    SeeAllLabel,
    columnWidth,
    gridPadding,
    rowHeight,
    category,
    getStyle,
    index,
    enableSlide,
    data
  } = props;
  const ref = useRef<HTMLDivElement>(null);
  const scrollLeft = useRef<number>(0);
  const maxWidth = getStyle('column')('maxWidth');
  const stylesSeeAll = getStyle('seeAll');
  const onScroll = useCallback(() => {
    if (!ref.current) return;
    scrollLeft.current = ref.current.scrollLeft;
  }, []);
  useEffect(() => {
    if (!category || !saveScrollPosition || !ref.current) return;
    const scrollPosition = getExploreScrollPosition(category);
    if (scrollPosition) {
      ref.current.scrollLeft = scrollPosition;
      scrollLeft.current = scrollPosition;
    }
    return () => {
      setExploreScrollPosition(category, scrollLeft.current);
    };
  }, [category, saveScrollPosition]);
  if (!data) {
    return null;
  }
  return <div ref={ref} onScroll={saveScrollPosition ? onScroll : undefined} style={{
    '--padding': gridPadding / 2 + 'px'
  } as CSSProperties} className={cx('no-scrollbars', stylesRoot, !enableSlide && isTouchDevice ? rowContainerTouchStyles : rowContainerStyles)}>
            {data.map((user, i) => {
      const {
        _key,
        id,
        placeholder
      } = user;
      const lastItem = i === data.length - 1;
      return <div style={{
        '--height': rowHeight - gridPadding + 'px',
        '--padding-right': gridPadding / 2 + 'px',
        '--padding-left': gridPadding / 2 + 'px',
        '--width': columnWidth + 'px'
      } as CSSProperties} key={_key || id} className={cx(rowStyles, placeholder && stylesPlaceholderCell)}>
                        {placeholder && <Placeholder displayHeight={displayHeight} tileHeight={rowHeight - gridPadding} />}
                        {!placeholder && lastItem && SeeAllComponent && <SeeAllComponent className={stylesSeeAllClass} styleOverrides={{
          '--height': (displayHeight || rowHeight - gridPadding) + 'px',
          '--font-size': stylesSeeAll('fontSize') + 'px'
        }} image={avatarUrl(id, maxWidth <= 150 ? 150 : 300)} onClick={seeAllOnClick} label={SeeAllLabel} />}
                        {!placeholder && (!lastItem || !SeeAllComponent) && <DisplayComponent {...displayComponentProps} {...user} columnIndex={i} index={index} />}
                    </div>;
    })}
        </div>;
};
export default UserRow;
export { UserRow };